module.exports = __webpack_public_path__ + "img/mint.87f0a0e8.gif";